import type { IconSvgObject } from './types';

const LocationUser01Icon: IconSvgObject = [
  ["path", { d: "M13.1977 8H10.8023C7.35836 8 5.03641 11.5806 6.39304 14.7994C6.58202 15.2477 7.0156 15.5385 7.49535 15.5385H8.33892C8.62326 15.5385 8.87111 15.7352 8.94007 16.0157L10.0261 20.4328C10.2525 21.3539 11.0663 22 12 22C12.9337 22 13.7475 21.3539 13.9739 20.4328L15.0599 16.0157C15.1289 15.7352 15.3767 15.5385 15.6611 15.5385H16.5047C16.9844 15.5385 17.418 15.2477 17.607 14.7994C18.9636 11.5806 16.6416 8 13.1977 8Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "5", r: "3", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export default LocationUser01Icon;
